import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { humanize } from 'underscore.string';
import { Modal, FormGroup, FormControl } from 'react-bootstrap';
import { withTranslation } from 'react-i18next';
import { sluggify } from 'utils/localization/utils';
import moment from 'moment';

const MAX_DRIVER_WAIT_TIME = 60;
const dateFormat = 'h:mma MMM D YYYY z';

function getExceptionMessage(props) {
  try {
    const { t, exception } = props;

    if (!exception) {
      return '';
    }

    const timezone =
      exception?.stop?.location[0]?.market?.timezone || 'America/Los_Angeles';

    return `${humanize(t(sluggify(exception?.exception_type)) || '')}: ${t(
      `${sluggify(exception?.exception_type)}_EXCEPTION_MESSAGE`,
      {
        date: moment(exception?.release_time).tz(timezone).format(dateFormat),
        max_driver_wait_time: MAX_DRIVER_WAIT_TIME,
        reason_description: exception?.description || '',
      },
    )}`;
  } catch (e) {
    console.error(e);
    return '';
  }
}

class ExceptionResolveModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      message: getExceptionMessage(props),
    };
  }

  static UNSAFE_componentWillReceiveProps(nextProps) {
    if (!this.props.show && this.nextProps.show) {
      this.setState({
        message: getExceptionMessage(nextProps),
      });
    }
  }

  onEditMessage() {
    return (e) => {
      this.setMessage(e.target.value);
    };
  }

  onSubmit() {
    if (Array.isArray(this.props.exception)) {
      for (let i = 0; i < this.props.exception.length; i += 1) {
        this.props.onResolve(this.props.exception[i]._id, this.state.message);
      }
    } else {
      this.props.onResolve(this.props.exception._id, this.state.message);
    }

    this.props.onCancel();
  }

  setMessage(message) {
    this.mergeState({ message });
  }

  mergeState(newState) {
    this.setState((prevState) => {
      return Object.assign(prevState, newState);
    });
  }

  render() {
    const { t } = this.props;
    return (
      (<Modal
        style={{ top: '25%' }}
        show={this.props.show}
        onHide={this.props.onCancel}
      >
        <Modal.Header data-testid="undefined-a9b40dc5">
          {this.props.exception != null &&
            Array.isArray(this.props.exception) && (
              <Modal.Title data-testid="undefined-534ff2d5">{t('RESOLVE_EXCEPTION')}</Modal.Title>
            )}
          {this.props.exception != null &&
            !Array.isArray(this.props.exception) && (
              <Modal.Title data-testid="undefined-1269bae0">
                {t('RESOLVE_EXCEPTION')}{' '}
                {this.props.show ? this.props.exception.case_id : ''}
              </Modal.Title>
            )}
        </Modal.Header>
        <Modal.Body data-testid="undefined-607a2f17">
          <FormGroup>
            <FormControl
              componentClass="textarea"
              placeholder={t('MESSAGE_PLACEHOLDER')}
              value={this.state.message}
              onChange={this.onEditMessage()}
            />
          </FormGroup>
        </Modal.Body>
        <Modal.Footer data-testid="undefined-4b5ac3b4">
          <button
            data-testid="button-156d9091"
            className="button button-red"
            onClick={this.props.onCancel}>
            {t('CANCEL')}
          </button>
          <button
            data-testid="button-5cf5fe3a"
            className="ml-2 button button-green exception-exceptionResolveModal-resolveException heap"
            onClick={() => this.onSubmit()}>
            {t('RESOLVE')}
          </button>
        </Modal.Footer>
      </Modal>)
    );
  }
}

ExceptionResolveModal.propTypes = {
  exception: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  onCancel: PropTypes.func.isRequired,
};

ExceptionResolveModal.defaultProps = {
  exception: null,
};

export default withTranslation()(ExceptionResolveModal);
